import { VERSION } from "$env";

export interface GlobalState {
	/** Whether the router finished loading the first route. */
	loaded: boolean;
	newestVersion: string;
	userAgent?: string;
	/** An error that occurred during route hooks. */
	routeError?: Error;
}

export const globalState = $state<GlobalState>({
	loaded: false,
	newestVersion: VERSION,
	routeError: undefined,
});
